module.exports = __webpack_public_path__ + "static/media/welcomeBG.e457cf18.png";